import { Breadcrumbs } from "@/components/Breadcrumbs";
import { MaskText, Reveal } from "@/components/Reveal";
import { cn } from "@/lib/utils";

export default function PageHero({
  overline,
  title,
  titleLines,
  subtitle,
  crumbs = [],
  image,
  align = "left",
  children,
}) {
  const lines = titleLines || (title ? [title] : []);
  return (
    <section className="relative overflow-hidden bg-navy pt-[74px] text-white md:pt-[88px]">
      <div className="grid-texture pointer-events-none absolute inset-0 opacity-50" />
      {image && (
        <>
          <div
            className="pointer-events-none absolute inset-0 bg-cover bg-center opacity-25"
            style={{ backgroundImage: `url(${image})` }}
          />
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-navy via-navy/85 to-navy/40" />
        </>
      )}
      <div
        className={cn(
          "relative mx-auto max-w-shell px-6 py-20 md:px-12 md:py-28 lg:py-32",
          align === "center" && "text-center"
        )}
      >
        <div className={cn(align === "center" ? "mx-auto max-w-3xl" : "max-w-4xl")}>
          <div className={cn(align === "center" && "flex justify-center")}>
            <Breadcrumbs crumbs={crumbs} dark />
          </div>
          {overline && (
            <Reveal delay={0.1}>
              <p className="mt-8 font-mono text-xs uppercase tracking-[0.22em] text-energy">
                {overline}
              </p>
            </Reveal>
          )}
          <h1 className="mt-4 font-heading text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
            <MaskText lines={lines} delay={0.15} />
          </h1>
          {subtitle && (
            <Reveal delay={0.4}>
              <p
                className={cn(
                  "mt-6 text-lg leading-relaxed text-white/70",
                  align === "center" ? "mx-auto max-w-2xl" : "max-w-2xl"
                )}
              >
                {subtitle}
              </p>
            </Reveal>
          )}
          {children && (
            <Reveal delay={0.5}>
              <div className="mt-9">{children}</div>
            </Reveal>
          )}
        </div>
      </div>
    </section>
  );
}
